<script lang="ts">
    import type { Stat } from './appTypes.js';

    export let stats: Stat[] = [];
</script>

<dl class="stat-grid">
    {#each stats as stat}
        <div class="stat">
            {#if stat.icon}<i class="{stat.icon} icon" aria-hidden="true"></i>{/if}
            <dt class="stat-label">{stat.label}</dt>
            <dd class="stat-value">{stat.value}</dd>
            {#if stat.hint}<div class="stat-hint">{stat.hint}</div>{/if}
        </div>
    {/each}
</dl>

<style>
    .stat-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: var(--space-4);
        margin: 0 0 var(--space-6) 0;
        padding: 0;
    }

    .stat {
        background: var(--surface);
        border: 1px solid var(--border-color);
        border-radius: var(--radius-card);
        box-shadow: var(--shadow-card);
        padding: var(--space-5);
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
    }

    .stat :global(i.icon) {
        color: var(--primary);
        font-size: var(--text-xl);
        margin: 0 0 var(--space-2) 0;
    }

    .stat-label {
        font-size: var(--text-sm);
        color: var(--grey-secondary);
        margin: 0;
    }

    .stat-value {
        font-size: var(--text-2xl);
        font-weight: 500;
        color: var(--grey);
        margin: 0;
        font-variant-numeric: tabular-nums;
    }

    .stat-hint {
        font-size: var(--text-xs);
        color: var(--grey-secondary);
    }
</style>
